module.exports = __webpack_public_path__ + "bb.d35efe6b.svg";